import React, { FC } from 'react';

import { useQuery } from '@apollo/client';

import ItemList from 'inruta-commons/lib/components/itemlist/list/ItemList';
import ItemData from 'inruta-commons/lib/components/itemlist/item/ItemData';
import ItemTile from 'inruta-commons/lib/components/itemlist/item/ItemTile';
import ItemCell from 'inruta-commons/lib/components/itemlist/item/ItemCell';
import { Box } from '@material-ui/core';
import GET_ALL_PRODUCTS from '../../commons/gql/remote/GetAllProducts';
import Page from '../page/Page';

const itemDataFromProduct = (product: any) => ({
  imageUrl: product.image,
  label: product.inRutaShortDescriptionSpanish,
  accessories: [
    product.inRutaShortDescriptionSpanish,
  ],
} as ItemData);

const AllProductsPage: FC = () => {
  const { loading, data } = useQuery(GET_ALL_PRODUCTS);

  if (loading) return <div />;

  // Filter items
  const products = data?.getProducts;
  const items: ItemData[] = products?.map((product: any) => itemDataFromProduct(product));

  // Build item list
  const itemList = (
    <ItemList
      itemCount={() => items?.length ?? 0}
      itemForSizeAtIndex={(size, index) => ((size === 'xs' || size === 'sm') ? <ItemTile motionProps={{}} key={index} itemData={items[index]} /> : <ItemCell key={index} itemData={items[index]} />)}
    />
  );

  return (
    <Page>
      <Box style={{ maxHeight: '50rem', overflowY: 'scroll' }}>
        { itemList }
      </Box>
    </Page>
  );
};

export default AllProductsPage;
